import { Component, OnInit } from '@angular/core';
import { Paho } from 'ng2-mqtt/mqttws31';
import { GuidService } from './guid.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DonateScreenData } from './donate-screen/donate-screen-data';
import { SettingData } from './setting-data';
import { DonateData } from './donate-data';
import { DonateChangeService } from './donate-change.service';
import { CheckUidService } from './check-uid.service';
import { SettingService } from './setting.service';
import { ControlService } from './controll-screen/control.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CookieService } from 'ngx-cookie-service';
import { SendMessageService } from './send-message.service';
import { CheckIdService } from './check-id.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  client: any;
  isConnect: boolean;
  mqttbroker = 'mania.app';
  donateScreenData: DonateScreenData;
  donateDataList: Array<DonateData> = [];
  donateData: DonateData;
  currentDonateData: DonateData;
  app: string;
  constructor(
    private router: Router,
    private activatedRouter: ActivatedRoute,
    private donateChange: DonateChangeService,
    private checkUID: CheckUidService,
    private settingService: SettingService,
    private controlService: ControlService,
    private _snackBar: MatSnackBar,
    private cookieService: CookieService,
    private sendMessage: SendMessageService,
    private checkIDService: CheckIdService
  ) {}

  ngOnInit() {
    console.log(location.protocol);
    this.client = new Paho.MQTT.Client(
      this.mqttbroker,
      Number(8084),
      GuidService.newGuid()
    );
    this.client.onMessageArrived = this.onMessageArrived.bind(this);
    this.client.onConnectionLost = this.onConnectionLost.bind(this);
    this.client.connect({ onSuccess: this.onConnect.bind(this), useSSL: true });
  }

  onConnect() {
    console.log('onConnect');
    this.isConnect = true;
  }

  onConnectionLost(responseObject) {
    if (responseObject.errorCode !== 0) {
      this.isConnect = false;
      console.log('onConnectionLost:' + responseObject.errorMessage);
    }
  }

  onMessageArrived(message) {
    console.log(
      'onMessageArrived: ' +
        message.destinationName +
        ': ' +
        message.payloadString
    );
    const jsonData = JSON.parse(message.payloadString);
    if (message.destinationName.indexOf('donate') !== -1) {
      if (message.destinationName.indexOf('res') !== -1) {
        this.currentDonateData = new DonateData(
          jsonData.id,
          jsonData.name,
          jsonData.donate,
          jsonData.yt,
          jsonData.stime,
          jsonData.time,
          jsonData.msg,
          jsonData.pic1,
          jsonData.pic2
        );
        this.donateDataList.push(this.currentDonateData);
        this.donateChange.update(this.currentDonateData);
        this.donateChange.updateDonateList(this.donateDataList);
      }
    }
    if (message.destinationName.indexOf('control_song') !== -1) {
      if (message.destinationName.indexOf('res') !== -1) {
        this.currentDonateData = new DonateData(
          jsonData.id,
          jsonData.name,
          jsonData.donate,
          jsonData.yt,
          jsonData.stime,
          jsonData.time,
          jsonData.msg,
          jsonData.pic1,
          jsonData.pic2
        );
        this.donateChange.update(this.currentDonateData);
      }
    } else if (message.destinationName.indexOf('control_msg') !== -1) {
      if (message.destinationName.indexOf('send') !== -1) {
        if (jsonData.action === 'changeVolume') {
          this.controlService.changeVolume(jsonData.msg);
        } else if (jsonData.action === 'changeVoiceVolume') {
          this.controlService.changeVoiceVolume(jsonData.msg);
        }
      }
    } else if (message.destinationName.indexOf('control') !== -1) {
      if (message.destinationName.indexOf('res') !== -1) {
        if (jsonData.list) {
          this.donateDataList = [];
          jsonData.list.forEach((element) => {
            this.donateDataList.push(
              new DonateData(
                element.id,
                element.name,
                element.donate,
                element.yt,
                element.stime,
                element.time,
                element.msg,
                jsonData.pic1,
                jsonData.pic2
              )
            );
          });
          // this.currentDonateData = this.donateDataList[0];
          this.donateChange.updateDonateList(this.donateDataList);
          // this.donateChange.update(this.currentDonateData);
        } else if (jsonData.msg === 'playend') {
          console.log('play end');
          this.controlService.updateTime(999999);
          this.donateChange.updateTime(999999);
        } else if (jsonData.msg === 'stop') {
          console.log('stop play');
          this.controlService.updateTime(0);
          this.donateChange.updateTime(0);
        } else if (jsonData.msg === 'play') {
          this.controlService.playVideo();
        } else if (jsonData.msg === 'pause') {
          this.controlService.pauseVideo();
        } else {
          this.currentDonateData = new DonateData(
            jsonData.id,
            jsonData.name,
            jsonData.donate,
            jsonData.yt,
            jsonData.stime,
            jsonData.time,
            jsonData.msg,
            jsonData.pic1,
            jsonData.pic2
          );
          this.donateChange.update(this.currentDonateData);
          this.donateDataList.push(this.currentDonateData);
        }
      }
    }
    if (message.destinationName.indexOf('setting') !== -1) {
      if (message.destinationName.indexOf('res') !== -1) {
        if (jsonData.msg === 'ok') {
          this._snackBar.open('設定完成', '關閉', {
            duration: 2000,
            panelClass: 'copyalert',
          });
        }
      }
    }
    if (message.destinationName.indexOf('account') !== -1) {
      if (message.destinationName.indexOf('res') !== -1) {
        const settingData = new SettingData(
          jsonData.min_money,
          jsonData.id,
          jsonData.isloop,
          jsonData.times,
          jsonData.basetime,
          jsonData.img1,
          jsonData.img2,
          jsonData.img3,
          jsonData.img4,
          jsonData.msg,
          jsonData.opay_payment_hash,
          jsonData.volume,
          jsonData.voiceVolume
        );
        this.settingService.update(settingData);
      }
    }
    if (message.destinationName.indexOf('verify') !== -1) {
      if (message.destinationName.indexOf('res') !== -1) {
        if (jsonData.msg === 'ok') {
          alert('註冊成功');
          const id = this.cookieService.get('id');
          this.router.navigate(['/setting/' + id]);
          this.cookieService.set('id', id, 999999, '/');
        } else {
          alert('註冊失敗 此id已存在');
          this.cookieService.delete('id', '/');
          this.cookieService.delete('uid', '/');
          this.router.navigate(['/']);
        }
      }
    }
    if (message.destinationName.indexOf('check') !== -1) {
      if (message.destinationName.indexOf('res') !== -1) {
        if (jsonData.msg === 'ok') {
          this.checkUID.update(1);
        } else {
          this.checkUID.update(2);
        }
      }
    }
    if (message.destinationName.indexOf('get_id') !== -1) {
      if (message.destinationName.indexOf('res') !== -1) {
        if (jsonData.msg !== '') {
          this.cookieService.set('id', jsonData.msg, 999999, '/');
          if (this.app) {
            this.sendMessage.sendMessage(
              this.client,
              JSON.stringify({
                uid: this.cookieService.get('uid'),
                id: jsonData.msg,
              }),
              'app_login/' + this.app + '/send'
            );
            window.close();
          }
          this.router.navigate(['/setting/' + jsonData.msg]);
        } else {
          // alert('登入失敗');
          this.cookieService.delete('id', '/');
          this.cookieService.delete('uid', '/');
          this.checkUID.update(1);
        }
      }
    }
    if (message.destinationName.indexOf('window_check') !== -1) {
      if (message.destinationName.indexOf('send') !== -1) {
        const obj = { id: jsonData.id, msg: 'opened' };
        const msg = JSON.stringify(obj);
        this.sendMessage.sendMessage(
          this.client,
          msg,
          'window_check/' + jsonData.id + '/res'
        );
      }
      if (message.destinationName.indexOf('res') !== -1) {
        if (jsonData.msg === 'opened') {
          this.controlService.updateControlState(1);
        } else {
          this.controlService.updateControlState(0);
        }
      }
    }
    if (message.destinationName.indexOf('check_id') !== -1) {
      if (message.destinationName.indexOf('res') !== -1) {
        if (jsonData.msg === 'ok') {
          this.checkIDService.update(1);
        } else {
          this.checkIDService.update(2);
        }
      }
    }
    if (message.destinationName.indexOf('app_login') !== -1) {
      if (message.destinationName.indexOf('send') !== -1) {
        this.cookieService.set('uid', jsonData.uid, 999999, '/');
        this.cookieService.set('id', jsonData.id, 999999, '/');
        this.router.navigate(['/setting/' + jsonData.id]);
      }
    }
  }
}
